/* eslint-disable jsx-a11y/anchor-is-valid */
// import { toAbsoluteUrl } from '../../../_4threal/helpers' //omitted due to eslint warnings
// import RenameCardModal from './modal/RenameCardModal' //omitted due to eslint warnings
// import DeleteModal from './modal/DeleteCardModal' //omitted due to eslint warnings
import React from 'react'
import { FC, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { PageTitle } from '../../../_4threal/layout/core'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { deleteMarker, getDeletedMarkers, updateMarker, getMarkers, getSharedMarkers } from '../../../redux/action/card'
import { useSelector } from 'react-redux'
import { userProfile } from '../../../redux/action/auth'
import { getPlanById } from '../../../redux/action/plan'
import DeleteCardModal from './modal/DeleteCardModal'
import timeSince from '../../../utils/timesince'
import { Flow } from '../../modules/cardform/components/editors/WalkthroughSteps'
import './dashboard.css'
// import CheckActivePlan from '../Plandetail/ActivePlan/CheckActivePlan'
// import PaymentWarning from '../../../_4threal/layout/components/sidebar/PaymentWarning'

const MarkerPage: FC = () => {
  // const [currentPage, setCurrentPage] = useState(1) //setCurrentPage never gets called, so making currentPage a const
  const currentPage = 1
  const itemsPerPage = 50 // Number of items to display per page
  const dispatch = useDispatch()
  // const [loading, setLoading] = React.useState(true)
  const [open, setOpen] = React.useState(false)
  const [type, setType] = React.useState('delete')
  const [markerId, setMarkerId] = React.useState("")
  const [currMarker, setMarker] = React.useState({})
  const Allmarkerdata = useSelector((state: any) => state.Marker?.UserMarker)
  const [AllMarkers, setAllMarkers] = React.useState<any>([])
  const [SharedMarkers, setSharedMarkers] = React.useState<any>([])
  const navigate = useNavigate()
  const [pname, setPname] = React.useState("")
  const userId = useSelector((state: any) => state._id)
  // const userdata = useSelector((state: any) => state)
  // const userId = userdata?._id
  // const currentPlan = useSelector((state: any) => state?.Auth?.authProfile?.payments)
  // const activePlan = CheckActivePlan(currentPlan)

  const token = localStorage.getItem('userId')
  useEffect(() => {
    if (token) {
      dispatch(userProfile(token))
      dispatch(getPlanById(token))
      // setLoading(false) //unused, omitting for now
    } else {
      // setLoading(false) //unused, omitting for now
    }
  }, [dispatch, token])

  useEffect(() => {
    if (Allmarkerdata) {
      setAllMarkers(Allmarkerdata)
    }
  }, [Allmarkerdata])


  const handleLinkClick = (link) => {
    // Reset any global state here before navigating
    window.location.href = link;
  };


  // Calculate total number of pages
  // const totalPages = Math.ceil(Allcard?.data?.totalCount / itemsPerPage) //omitting due to eslint warning

  // Function to handle page change
  //omitting due to eslint warning
  // const handlePageChange = (newPage) => {
  //   setCurrentPage(newPage)
  // }

  const handleDownload = async (fileUrl, name) => {
    try {
      // Fetch the image
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      
      // Detect file extension from blob MIME type
      let extension = 'png'; // default
      const mimeType = blob.type;
      
      if (mimeType === 'image/svg+xml') {
        extension = 'svg';
      } else if (mimeType === 'image/png') {
        extension = 'png';
      } else if (mimeType === 'image/jpeg' || mimeType === 'image/jpg') {
        extension = 'jpg';
      } else if (mimeType === 'image/webp') {
        extension = 'webp';
      } else if (mimeType === 'application/pdf') {
        extension = 'pdf';
      } else {
        // Fallback: try to detect from URL
        const urlExtension = fileUrl.split('.').pop()?.split('?')[0];
        if (urlExtension && ['svg', 'png', 'jpg', 'jpeg', 'webp', 'pdf'].includes(urlExtension.toLowerCase())) {
          extension = urlExtension.toLowerCase();
        }
      }
      
      // File name with detected extension
      const fileName = `${name}.${extension}`;
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a temporary anchor element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Clean up the Blob URL
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading the file', error);
    }
  }


  const handleGetAllMarkers = () => {
    dispatch(getMarkers({ currentPage, itemsPerPage, userId })).then((res) => {
      setAllMarkers(res)
      //console.log(res)
    })
  }

  const handleGetSharedMarkers = () => {
    dispatch(getSharedMarkers()).then((res) => {
      setSharedMarkers(res)
      //console.log('Shared markers:', res)
    }).catch((error) => {
      console.error('Error fetching shared markers:', error)
      setSharedMarkers([])
    })
  }



  useEffect(() => {
    handleGetAllMarkers()
    handleGetSharedMarkers()
  }, [currentPage, itemsPerPage, userId]) // eslint-disable-line react-hooks/exhaustive-deps
  //we want to avoid calling handleGetAllCard() every frame, so keep it out of the dependency array

  const handleDelete: any = (id: any) => {
    const updatedData = AllMarkers?.map((data) => {
      if (data?._id === markerId) {
        return { ...data, isDeleted: true }
      } else {
        return data
      }
    })
    setAllMarkers(updatedData)
    setOpen(false)
    dispatch(deleteMarker(markerId)).then(() => {
      handleGetAllMarkers()
      dispatch(getDeletedMarkers())
    })
  }

  const handleRename: any = () => {
    let marker = {}
    const updatedData = AllMarkers?.map((data) => {
      if (data?._id === markerId) {
        marker = { ...data, name: pname };
        return marker
      } else {
        return data
      }
    })

    setAllMarkers(updatedData)
    setOpen(false)
    dispatch(updateMarker(marker)).then(() => {
      handleGetAllMarkers()
    })
  }

  const handleTextChange = (value) => {
    setPname(value);
  };



  const handleOpen = (id: any, type: string) => {
    setOpen(true)
    setType(type)
    setMarkerId(id)
    let marker = AllMarkers?.filter((data) => data?._id === id)
    setMarker(marker[0])
    if (marker?.name) {
      setPname(marker?.name)
    } else {
      setPname("")
    }
  }

  const handleClose = () => {
    setOpen(false)
  }

  const renderMarkerCard = (e: any, i: number, isShared: boolean = false) => {
    return (
      <div className='col-12 col-sm-12 col-md-6 col-lg-4 mt-5' key={`${isShared ? 'shared' : 'own'}-${e._id || i}`}>
        <div className={`w-100 h-250px position-relative border rounded d-flex flex-column justify-content-center align-items-center p-15 ${isShared ? 'border-info' : ''}`}>
          <div 
            className='cur-pointer'
            onClick={() => handleLinkClick(`/vcard/compiler/${Flow.markeronly}/${e._id}-m`)}
          >
            <img
              style={{ 
                filter: 'drop-shadow(5px 5px 4px #222222)', 
                height:'160px' 
              }}
              src={e?.compiledImageUrl}
              alt=''
            />
            <div style={{ top: '6px', left: '6px' }} className='position-absolute'>
              {!isShared ? (<svg
                width='45'
                height='22'
                viewBox='0 0 45 22'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <rect width='45' height='22' rx='11' fill='green' fillOpacity='0.4' />
                <path
                  d='M11.299 16V6.77H12.391V14.934H17.019V16H11.299ZM18.7363 9.11H19.8023V16H18.7363V9.11ZM18.7103 8.031V6.796H19.8283V8.031H18.7103ZM27.5627 9.11L25.0407 16H23.7147L21.1927 9.11H22.3367L24.3777 14.882L26.4187 9.11H27.5627ZM28.132 12.555C28.132 10.371 29.367 8.954 31.278 8.954C32.812 8.954 34.151 9.981 34.268 12.412L34.281 12.893H29.263C29.367 14.31 30.082 15.142 31.278 15.142C32.032 15.142 32.708 14.7 33.02 13.972L34.164 14.05C33.761 15.35 32.604 16.156 31.278 16.156C29.367 16.156 28.132 14.739 28.132 12.555ZM29.289 11.944H33.111C32.916 10.488 32.136 9.968 31.278 9.968C30.173 9.968 29.458 10.696 29.289 11.944Z'
                  fill='white'
                />
              </svg>): (
                  <span className="badge bg-info text-light rounded-pill px-3 py-2" style={{ fontSize: '0.7rem', fontWeight: 'bold' }}>
                    <i className="bi bi-share me-2"></i>
                    Shared
                  </span>
              )}
            </div>
            
            {/* Shared Badge */}
          </div>
          <div style={{ top: '6px', right: '1px' }} className='position-absolute drop-arrow-hide'>
            <button className="bg-transparent border-0 dropdown-toggle dropdown-toggle-split more-hover" data-bs-toggle="dropdown" aria-expanded="false">
              <div className="svg-container">
                <svg className="svg-icon" width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fillRule="evenodd" clipRule="evenodd" d="M0.599609 2.00002C0.599609 1.1162 1.31578 0.400024 2.19961 0.400024C3.08344 0.400024 3.79961 1.1162 3.79961 2.00002C3.79961 2.88385 3.08344 3.60002 2.19961 3.60002C1.31578 3.60002 0.599609 2.88385 0.599609 2.00002Z" fill="#444444" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M7.39941 2.00002C7.39941 1.1162 8.11559 0.400024 8.99941 0.400024C9.88324 0.400024 10.5994 1.1162 10.5994 2.00002C10.5994 2.88385 9.88324 3.60002 8.99941 3.60002C8.11559 3.60002 7.39941 2.88385 7.39941 2.00002Z" fill="#444444" />
                  <path fillRule="evenodd" clipRule="evenodd" d="M14.1992 2.00002C14.1992 1.1162 14.9154 0.400024 15.7992 0.400024C16.683 0.400024 17.3992 1.1162 17.3992 2.00002C17.3992 2.88385 16.683 3.60002 15.7992 3.60002C14.9154 3.60002 14.1992 2.88385 14.1992 2.00002Z" fill="#444444" />
                </svg>

                <svg className="overlay-icon" width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="15" cy="15" r="15" fill="black" fillOpacity="0" />
                </svg>
              </div>
            </button>
            <ul className="dropdown-menu p-4 mt-3 w-100 px-3">
              <li className='pt-2 cursor-pointer' onClick={() => navigate(`/analytics/overview/${e._id}`)}>
                <div className='d-flex gap-2 align-items-center' style={{ width: "max-content" }}>
                  <i style={{ color: 'black' }} className='bi bi-bar-chart-line-fill fs-3'></i>
                  View Analytics
                </div>
              </li>
              <li className='pt-2 cursor-pointer' onClick={() => handleDownload(e?.compiledImageUrl, e?.name || 'custom_print')}>
                <div className='d-flex gap-2 align-items-center' style={{ width: "max-content" }}>
                  <i style={{ color: 'black' }} className='bi bi-download fs-3'></i>
                  Download
                </div>
              </li>
            </ul>
          </div>

        </div>
              
        <div>
          <div className="row">
            <div style={{ fontSize: '11px', fontStyle: 'bold' }} className='my-2 font-gray1 col-6'>
              {e?.name ? e.name : 'Project ' + (i + 1)}
              <span
                style={{
                  fontStyle: 'bold',
                  color: '#0dcaf0',
                  marginLeft: '4px'
                }}
              >
                ({e?.scanCount ? e.scanCount : 'No'} Scans)
              </span>
            </div>
            <div style={{ fontSize: '11px', textAlign: 'right' }} className='my-2 font-gray1 col-6'>
              {e?.createdAt ? timeSince(e.createdAt) : ''  }
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      <div className='row w-100 m-auto relative'>
        {/* Own Markers */}
        {AllMarkers?.length > 0 || SharedMarkers?.length > 0 ? (
          <>
          {AllMarkers?.map((e, i) => {
            if (!e?.isDeleted) {
              return renderMarkerCard(e, i, false)
            }
            else return <></> //added this because eslint was complaining about not returning anything
          })}

          {/* Shared Markers */}
          {SharedMarkers?.map((e, i) => {
            if (!e?.isDeleted) {
              return renderMarkerCard(e, i, true)
            }
            else return <></>
          })}
          </>
        ):(
          <div className='col-12 col-sm-12 col-md-6 col-lg-4 mt-5 text-center w-100'>
          <div className='w-100 h-250px position-relative border rounded d-flex flex-column justify-content-center align-items-center p-15 text-center' style={{border:'1px solid black'}}>
            <h4>No Prints Found</h4>
          </div>
        </div>
        )}

        {/* {activePlan?.length === 0 && <PaymentWarning userData={userdata} />} */}
        <DeleteCardModal open={open} type={type} card={currMarker} handleClose={handleClose} del={handleDelete} rename={handleRename} rtext={handleTextChange} pname={pname} deleteType='marker' />
      </div >
    </>
  )
}

const MarkerWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[]}>{intl.formatMessage({ id: 'MENU.DASHBOARD' })}</PageTitle>
      <MarkerPage />
    </>
  )
}

export { MarkerWrapper }
